module.exports = __webpack_public_path__ + "static/img/AtWuhu-3.0ae41c8d.jpg";